import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"

import { logoutReset, logoutUser } from "../../store/actions"

//redux
import { useDispatch } from "react-redux"
import { useSession } from "../../routes/middleware/SessionContext"
import { GET_COMPANY_FROM_URL } from "../../components/Common/CommonFunction"

const Logout = props => {

  const dispatch = useDispatch()
  const { updateSessionActivity } = useSession();
  useEffect(() => {

    updateSessionActivity({
      session: false,
    })
    const CompanyCode = GET_COMPANY_FROM_URL();

    for (let key in localStorage) {
      
      if (
        key.startsWith(`${CompanyCode}_`) &&
        key !== `${CompanyCode}_companyCode` &&
        key !== `${CompanyCode}_companyTheme` &&
        key !== `${CompanyCode}_companyID` &&
        key !== `${CompanyCode}_LoginCaptcha`
      ) {
        localStorage.removeItem(key);
      }
    }
    localStorage.setItem("Logout", `${GET_COMPANY_FROM_URL()}`);
    sessionStorage.clear()
    dispatch(logoutUser(props.history))
    dispatch(logoutReset())

  }, [dispatch, props.history])


  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
